import React from "react";
import {
  SalesforcePageContext,
  useSalesforcePageContextFactory,
} from "../contexts/useSalesforcePageContext";
import { SalesforceWelcomeView } from "../views/SalesforceWelcomeView";
import { Navigate } from "react-router-dom";

export const SalesforceIntegrationPage: React.FC = () => {
  const context = useSalesforcePageContextFactory();

  if (context.loading) {
    return <></>;
  }

  if (context.error) {
    return <div>Error: {context.error.message}</div>;
  }

  return (
    <SalesforcePageContext.Provider value={context}>
      {context.orgs.length === 0 ? (
        <SalesforceWelcomeView />
      ) : (
        <Navigate to={`/integrations/salesforce/${context.orgs[0].id}`} />
      )}
    </SalesforcePageContext.Provider>
  );
};
